
<div :class="jel_getClassObject(content)">
  <avatar username="TO DO"></avatar>
  TODO: EnteteInfosPersonnelles
</div>
